import { Login } from '@/components';

import style from './Login.module.css';

export type LoginPageProps = {
  className?: string;
};

export const LoginPage = ({ className }: LoginPageProps) => {
  return (
    <div className={`${style['login-page']} ${className}`.trim()}>
      <Login />
    </div>
  );
};
